<ng-container *ngIf="keyValues; else loadingDetails">
    <dl class="sb-key-value-list" [class.sb-key-value-list-table]="useTableStyle">
        <div *ngFor="let keyValue of keyValues">
            <dt class="d-flex align-items-center align-self-start">
                {{ keyValue.key }}
                <sb-tooltip-info
                    *ngIf="keyValue.description"
                    [tooltipText]="keyValue.description"
                    size="sm"
                ></sb-tooltip-info>
            </dt>
            <dd>
                <ng-container [ngSwitch]="keyValue.type">
                    <ng-container *ngSwitchCase="'link'">
                        <a [href]="keyValue.value" target="_blank">
                            {{ keyValue.value | trimWebsiteUrl }}
                        </a>
                    </ng-container>
                    <span
                        *ngSwitchCase="'currency'"
                        [class.sb-change-prefix]="keyValue.addChangePrefix"
                        [class.text-positive]="
                            keyValue.useColor !== false && keyValue.value > 0
                        "
                        [class.text-negative]="
                            keyValue.useColor !== false && keyValue.value < 0
                        "
                    >
                        {{
                            keyValue.value
                                | formatCurrency$
                                    : currency
                                    : useShortNumberFormat
                                    : keyValue.value
                                    : keyValue.digitsInfo
                                | async
                        }}
                    </span>
                    <span
                        *ngSwitchCase="'number'"
                        [class.sb-change-prefix]="keyValue.addChangePrefix"
                        [class.text-positive]="
                            keyValue.useColor !== false && keyValue.value > 0
                        "
                        [class.text-negative]="
                            keyValue.useColor !== false && keyValue.value < 0
                        "
                    >
                        {{
                            keyValue.value
                                | formattedNumber$ : null : keyValue.digitsInfo
                                | async
                        }}
                    </span>
                    <span
                        *ngSwitchCase="'percent'"
                        [class.sb-change-prefix]="keyValue.addChangePrefix"
                        [class.text-positive]="
                            keyValue.useColor !== false && keyValue.value > 0
                        "
                        [class.text-negative]="
                            keyValue.useColor !== false && keyValue.value < 0
                        "
                    >
                        {{ keyValue.value | formattedPercent$ | async }}
                    </span>
                    <span *ngSwitchCase="'date'">
                        {{ keyValue.value | date : keyValue.format || 'shortDate' }}
                    </span>
                    <span *ngSwitchCase="'fileSize'">
                        {{ keyValue.value | fileSize }}
                    </span>
                    <ng-container *ngSwitchDefault>
                        {{ keyValue.value }}
                    </ng-container>
                </ng-container>
            </dd>
        </div>
    </dl>
</ng-container>
<ng-template #loadingDetails>
    <div class="skeleton-loader skeleton-loader-table mt-4" aria-busy="true">
        <span class="visually-hidden">Loading details</span>
    </div>
</ng-template>
